import React from "react";
import { Link } from "react-router-dom";

const EN_PDF = "/downloads/mealpill-food-guide-metro-vancouver-en.pdf";
const UA_PDF = "/downloads/mealpill-food-guide-metro-vancouver-ua.pdf";

/**
 * The printed guide, given away. Reached from an emailed link (/r/orgs) and from
 * the QR inside the guide itself, so most visitors arrive here having never seen
 * the landing page.
 *
 * English only, deliberately. The page is the landing spot for one English
 * mailing to settlement agencies and parishes; the choice of language belongs to
 * the file being downloaded, not to the page offering both.
 *
 * Nothing is asked for: no account, no email, no form. The mailing says "nothing
 * to sign up for", and that sentence has to survive contact with this page.
 */
export default function GuidePage() {
  return (
    <div className="min-h-screen bg-[#FAFAF8] text-[#3D4035]">
      <header className="border-b border-black/5">
        <div className="max-w-2xl mx-auto px-6 py-6 flex items-center justify-between">
          <Link to="/" className="text-[#7B9E7F] font-medium hover:opacity-80 transition">
            &larr; MealPill
          </Link>
        </div>
      </header>

      <main className="max-w-2xl mx-auto px-6 py-12">
        <h1
          className="text-4xl md:text-5xl font-serif mb-3"
          style={{ fontFamily: "'Cormorant Garamond', Georgia, serif" }}
        >
          Food in Metro Vancouver
        </h1>
        <p className="text-lg text-[#3D4035]/70 mb-12 leading-relaxed">
          A practical guide to free and affordable food, smart shopping, and
          making groceries last. Updated August 2026.
        </p>

        <div className="bg-white border border-black/5 rounded-2xl p-8 mb-8 shadow-sm">
          <p className="text-[15px] leading-relaxed text-[#3D4035]/80">
            26 pages: food banks and hamper programs, free community meals and
            211, where to find Ukrainian products and what to substitute, how
            loyalty programs and discount apps actually work, storing food so it
            lasts, and what groceries realistically cost per month.
          </p>

          <div className="mt-8 flex flex-col sm:flex-row gap-3">
            <a
              href={EN_PDF}
              download
              className="px-5 py-2.5 rounded-lg bg-[#7B9E7F] text-white text-[15px] font-medium text-center hover:opacity-90 transition"
            >
              Download — English (PDF)
            </a>
            <a
              href={UA_PDF}
              download
              className="px-5 py-2.5 rounded-lg bg-[#7B9E7F] text-white text-[15px] font-medium text-center hover:opacity-90 transition"
            >
              Завантажити — українською (PDF)
            </a>
          </div>

          <p className="mt-4 text-sm text-[#3D4035]/70">
            Free to print, forward, or hand out.
          </p>
        </div>

        <p className="text-xs text-[#3D4035]/55 leading-relaxed">
          Compiled from public sources, August 2026. Details change — call ahead
          before visiting. Not affiliated with the organizations listed.
        </p>

        <footer className="mt-20 pt-8 border-t border-black/10 text-sm text-[#3D4035]/60">
          <Link to="/" className="hover:text-[#3D4035] transition">
            MealPill — meal plans built from what you already have at home. The
            demo needs no account.
          </Link>
        </footer>
      </main>
    </div>
  );
}
